import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 z-10 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_2 = { class: "fixed inset-0 z-10 w-screen overflow-y-auto" }
const _hoisted_3 = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_4 = { class: "relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 w-full md:max-w-4xl sm:p-6" }
const _hoisted_5 = { class: "mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-brand-primary-100" }

import { ref, markRaw, watch } from 'vue'
import { useRouter } from 'vue-router';
import UserService from '@/services/UserService';
import { useUserStore } from '@/stores/UserStore';
import { storeToRefs } from 'pinia';

import { BuildingStorefrontIcon } from '@heroicons/vue/24/outline'
import DividerLabelLeft from '@/components/ui/DividerLabelLeft.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardingModal',
  setup(__props) {

const router = useRouter();
const userStore = useUserStore();
const {user: currentUser} = storeToRefs(userStore);

const form = ref({id: '', hasOnboarded: true});

const library = markRaw({
	DividerLabelLeft: DividerLabelLeft
})

const onboardingFormSchema = [
	{
		$cmp: 'DividerLabelLeft',
		props: {
			label: 'Welcome, let\'s get started!'
		}
	},
	{
		$el: 'div',
		attrs: {
			class: 'grid grid-cols-2 gap-4'
		},
		children: [
			{
				$formkit: 'text',
				name: "firstName",
				label: "First Name",
				placeholder: "First Name",
				validation: 'required'
			},
			{
				$formkit: 'text',
				name: "lastName",
				label: "Last Name",
				placeholder: "Last Name",
				validation: 'required'
			}
		]
	},
	{
		$cmp: 'DividerLabelLeft',
		props: {
			label: 'Reason for Joining'
		}
	},
		{
		$el: 'div',
		attrs: {
			class: 'grid grid-cols-2 gap-4'
		},
		children: [
			{
				$formkit: 'select',
				name: 'jobTitle',
				label: "I am a",
				placeholder: "Please choose",
				validation: 'required',
				options: {
					'Pracitioner': 'Pracitioner',
					'DSO': 'DSO',
					'Associate': 'Associate',
					'Employee': 'Employee',
					'Student': 'Student',
					'Other': 'Other'
				}
			},
					{
				$formkit: 'select',
				name: 'persona',
				label: "Interested in",
				placeholder: "Please choose",
				validation: 'required',
				options: {
					buyer: 'Buying a Practice',
					seller: 'Selling my Practice',
					partner: 'Partnering',
				}
			},
		]
	}
]
function handleOnboardRedirect() {
	const personaMap: Record<string, string> = {
		buyer: 'ListingsPage',
		seller: 'NewPracticePage',
		partner: 'ListingsPage',
	};

	if (currentUser.value && currentUser.value.hasOnboarded) {
		const persona = currentUser.value.persona;
		const routeName = personaMap[persona] || 'Home';
		router.push({ name: routeName });
	}
}
function handleSubmit() {
	UserService.update(form.value).then((response) => {
		userStore.setUser(response.data)
		handleOnboardRedirect()
	})
}


watch(
	() => userStore.user,
	(newUser) => {
		if (newUser) {
			form.value = {
				...form.value,
				id: newUser.id,
			};
		}
	},
	{ immediate: true }
);


return (_ctx: any,_cache: any) => {
  const _component_FormKitSchema = _resolveComponent("FormKitSchema")!
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(BuildingStorefrontIcon), {
                class: "h-10 w-10 text-brand-primary-600",
                "aria-hidden": "true"
              })
            ]),
            _createVNode(_component_FormKit, {
              type: "form",
              modelValue: form.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form).value = $event)),
              onSubmit: handleSubmit
            }, {
              default: _withCtx(() => [
                _createVNode(_component_FormKitSchema, {
                  schema: onboardingFormSchema,
                  library: _unref(library)
                }, null, 8, ["library"])
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])
      ])
    ])
  ]))
}
}

})